module.exports = __webpack_public_path__ + "img/shirt-tank-top.49854bb3.svg";